import * as pathToRegexp from 'path-to-regexp'

const router = (route: string, options?: { [key: string]: string }): string => {
  const toPath = pathToRegexp.compile(route)

  return toPath(options)
}

export default router
